namespace $.$$ {
	$mol_style_define($bog_formigo_builder_props, {
		flex: {
			basis: '20rem',
		},
		Body_content: {
			padding: $mol_gap.block,
		},
	})
}
